import { Box, TextField } from '@mui/material';
import { getReportLanguage } from '../components/reportLanguageSelector';
import { ReportSectionComponentType } from '../types';
import { useReportUpdater } from '../hooks/useReportUpdater';
import EmptySectionWarning from '../components/emptySectionWarning';
import ReportPreviewButton from '../components/reportPreviewButton';
import StepFooter from '../../common/components/stepFooter';

/**
 * Report executive summary step
 */
const ExecutiveSummaryStep: ReportSectionComponentType = ({
  sectionName,
  report,
  onClickBack,
  onClickNext,
  isLoading: isSomethingLoading,
}) => {
  const { getPropertyValue, isLoading, saveChanges, setPropertyValue, sectionData } =
    useReportUpdater({ report, sectionName });

  const handleClickNext = (): void => {
    saveChanges().then(() => onClickNext());
  };

  if (!sectionData) {
    return <EmptySectionWarning />;
  }

  return (
    <Box className="space-y-4">
      <TextField
        fullWidth
        multiline
        rows={5}
        value={getPropertyValue('description')}
        label="Optional comments"
        onChange={({ target: { value } }): void => setPropertyValue('description', value)}
      />
      <ReportPreviewButton
        isLoading={isLoading}
        onClickPreview={saveChanges}
        language={getReportLanguage(report)}
        reportId={report.id}
        sectionName={sectionName}
      />
      <StepFooter
        isLoading={isLoading || isSomethingLoading}
        onClickBack={onClickBack}
        onClickNext={handleClickNext}
      />
    </Box>
  );
};

export default ExecutiveSummaryStep;
